<template>
  <v-container>
    <alert :type="alertType" @closealert="closeAlert" :alertShow="alertShow" :msg="alertMsg"></alert>
    <list-net v-if="choosenNetwork==null && path==''" @choosennetwork="showChoosenNetwork"></list-net>
    <manage-user
      v-if="choosenNetwork!=null && path=='manageUser'"
      :choosenNetwork="choosenNetwork"
      @back="backinfo"
    ></manage-user>
    <info-net
      v-if="choosenNetwork!=null && path=='info'"
      :choosenNetwork="choosenNetwork"
      @back="back"
      @edit="editNetwork"
      @error="error"
      @saved="saved"
      @user="editUserInNetwork"
    ></info-net>
    <edit-net
      v-if="(path=='edit')"
      :choosenNetwork="choosenNetwork"
      :path="path"
      @backinfo="backinfo"
      @error="error"
      @saved="saved"
    ></edit-net>
    <create-net v-if="(path=='create')" :path="path" @back="back" @error="error" @saved="saved"></create-net>
    <v-row v-if="path==''">
      <v-col class="text-center">
        <v-btn class="ma-2" tile outlined color="primary" @click="createNetwork">
          <v-icon left>mdi-plus-circle</v-icon>{{$t('Networks.create')}}
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ListNetworksComponent from "../DataHome/ListNetworks";
import CreateNetworkComponent from "./CreateNetwork";
import AlertComponent from "./Alert.vue";
import NetworkInfoComponent from "./NetworkInfo";
import EditNetworkComponent from "./EditNetwork";
import ManageUserInNetworkComponent from "./ManageUserInNetwork";

export default {
  props: {
    changedPath: String
  },
  components: {
    "list-net": ListNetworksComponent,
    "create-net": CreateNetworkComponent,
    "edit-net": EditNetworkComponent,
    alert: AlertComponent,
    "info-net": NetworkInfoComponent,
    "manage-user": ManageUserInNetworkComponent
  },

  data: () => ({
    choosenNetwork: null,
    path: "",
    alertMsg: "",
    alertType: "error",
    alertShow: false
  }),
  methods: {
    showChoosenNetwork: function(value) {
      this.choosenNetwork = value;
      this.path = "info";
      this.$emit("subpath", [
        { name: this.choosenNetwork.name, subpath: "netInfo" }
      ]);
    },
    createNetwork: function() {
      this.path = "create";
      this.$emit("subpath", [{ name: this.$t('Networks.create'), subpath: "create" }]);
    },
    editNetwork: function() {
      this.path = "edit";
      this.$emit("subpath", [
        { name: this.choosenNetwork.name, subpath: "netInfo" },
        {
          name: this.$t('Networks.edit'),
          subpath: "edit"
        }
      ]);
    },
    editUserInNetwork: function() {
      this.path = "manageUser";
      this.$emit("subpath", [
        { name: this.choosenNetwork.name, subpath: "netInfo" },
        {
          name: this.$t('Networks.manage'),
          subpath: "manageUser"
        }
      ]);
    },
    back: function() {
      this.choosenNetwork = null;
      this.path = "";
      this.$emit("subpath", [""]);
    },
    backinfo: function() {
      this.path = "info";
      this.$emit("subpath", [
        { name: this.choosenNetwork.name, subpath: "netInfo" }
      ]);
    },
    error: function(value) {
      console.log(value);
      this.alertMsg = value;
      this.alertType = "error";
      this.alertShow = true;
    },
    saved: function(value) {
      this.alertMsg = value;
      this.alertType = "success";
      this.alertShow = true;
      this.path = "";
      this.choosenNetwork = null;
      this.$emit("subpath", [""]);
    },
    closeAlert: function() {
      this.alertShow = false;
    }
  },
  watch: {
    changedPath: function(value) {
      if (value == "networks") {
        this.back();
      } else if (value == "netInfo") this.backinfo();
    }
  }
};
</script>